import axios from "axios";
import { cmsEnv, cmsHeaders } from "../exports/exports";
import { dynamicFailed } from "../hooks/useToast";

export const fetchEventBanner = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/events-banner`,
      {
        headers: {
          ...cmsHeaders,
          ...cmsEnv,
        },
      },
    );
    return response.data.slice(-1);
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
  }
};

export const fetchEventData = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/events-event?sort=from_date:asc`,
      {
        headers: {
          ...cmsHeaders,
          ...cmsEnv,
        },
      },
    );
    return response.data;
  } catch (error) {
    dynamicFailed("Server Error");
  }
};
